import api, { CITIES_URL } from "./api";

export const fetchAllCities = async () => {
  return await api.get(`${CITIES_URL}/`);
};

export const fetchLimitedCities = async () => {
  return await api.get("/cities/top");
};
